// 研究模式文档预览分享（免鉴权）
// TODO(zjx): 分享链接 path / query 参数名待与后端生成规则对齐
export default {
  path: '/research/document/share',
  name: 'researchDocumentShare',
  component: () =>
    import(
      /* webpackChunkName: 'research-document-share' */ '@/pages/aiAssistant/researchMode/documentShare/index.vue'
    ),
  meta: {
    requireAuth: false,
    hiddenNav: true,
    localeModules: ['researchEditor', 'aiChat']
  }
};
